module.exports = __webpack_public_path__ + "img/77_2.8ea16ba6.jpg";